var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.54,
    height: 100.124,
    viewBox: "0 0 111.54 100.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cca086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#d1b29d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 12.698,
    y1: -0.226,
    x2: 13.576,
    y2: -0.226,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 12.871,
    y1: -0.651,
    x2: 13.749,
    y2: -0.651,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.947,
    y1: 0.194,
    x2: 2.722,
    y2: 0.194,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Path_833",
    x: 42.579,
    y: 0,
    width: 45.057,
    height: 35.903,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_82",
    x: 5.169,
    y: 7.303,
    width: 24.84,
    height: 24.84,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_851",
    x: 5.962,
    y: 20.838,
    width: 43.398,
    height: 36.355,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084",
    transform: "translate(-189.446 5.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(189.446 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(35.238 2.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(0 40.198)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_628",
    "data-name": "Rectangle 628",
    width: 38.041,
    height: 12.994,
    transform: "translate(11.769 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M1514,387.469h0v13.1a13.551,13.551,0,1,1-11.547,20.643,10.363,10.363,0,0,0-8.823-4.942h0a5.477,5.477,0,0,0-5.2,7.246A27.2,27.2,0,0,0,1514,441.672h0a27.1,27.1,0,1,0,0-54.2Z",
    transform: "translate(-1464.804 -387.469)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M1434.141,409.563",
    transform: "translate(-1427.071 -402.913)",
    fill: "none",
    stroke: "#99c700",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(6.888 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M1464.92,387.469a10.309,10.309,0,0,1-20.4,0h-10.979v54.2h42.491v-54.2Z",
    transform: "translate(-1433.538 -387.469)",
    fill: "#2e2e2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-202.867-164.838v-25.429h42.379v25.429Zm42.386-12.329v-13.1a26.855,26.855,0,0,1,12.2,2.92l-6.581,11.4A13.5,13.5,0,0,0-160.481-177.167Z",
    transform: "translate(209.755 190.267)",
    fill: "#2e2e2d",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M1417.936,387.469a7.283,7.283,0,0,0-7.283,7.283v17.635h12.994V387.469Z",
    transform: "translate(-1410.653 -387.469)",
    fill: "#2e2e2d"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_630",
    "data-name": "Rectangle 630",
    width: 42.492,
    height: 12.255,
    transform: "translate(6.888 16.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M1543.8,520.962h-5.224a7.012,7.012,0,0,0-7.012,7.012h0a7.012,7.012,0,0,0,7.012,7.011h5.224a7.011,7.011,0,0,0,7.011-7.011h0a7.012,7.012,0,0,0-7.012-7.012Z",
    transform: "translate(-1495.172 -480.781)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M1472.886,254.525l-3.325-.468c-6.793-.955-13.061,3.306-13.927,9.47l-3.709,26.38,28.028,3.941,3.709-26.379C1484.528,261.3,1479.68,255.48,1472.886,254.525Z",
    transform: "translate(-1439.502 -253.923)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M1453.243,307.742a4.054,4.054,0,0,0,3.45,4.579l1.129-8.029A4.054,4.054,0,0,0,1453.243,307.742Z",
    transform: "translate(-1440.396 -289.102)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M1546.011,315.64l-1.129,8.029a4.054,4.054,0,1,0,1.129-8.029Z",
    transform: "translate(-1504.48 -297.061)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_631",
    "data-name": "Rectangle 631",
    width: 31.962,
    height: 24.766,
    rx: 12.383,
    transform: "translate(14.486 34.012) rotate(-81.997)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 0.818,
    cy: 0.818,
    r: 0.818,
    transform: "translate(24.335 17.818)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 0.818,
    cy: 0.818,
    r: 0.818,
    transform: "translate(32.867 19.018)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M6.757.8,1.139.014A.99.99,0,0,0,.05.642.951.951,0,0,0,.818,1.887l5.617.789a.991.991,0,0,0,1.089-.628A.951.951,0,0,0,6.757.8Z",
    transform: "translate(19.26 14.97) rotate(-17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M6.674,1.923,1.315.063A.99.99,0,0,0,.125.469.951.951,0,0,0,.637,1.838L6,3.7a.991.991,0,0,0,1.19-.406.953.953,0,0,0-.513-1.369Z",
    transform: "translate(32.192 14.925) rotate(4.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M1453.543,334.787l-2.307-.325a.173.173,0,0,1-.1-.288l2.594-2.876a.173.173,0,0,0-.105-.288l-2.671-.376a.174.174,0,0,0-.177.091l-2.369,4.49a.173.173,0,0,0,.129.252l1.936.272a.174.174,0,0,1,.133.246l-1.572,3.318a.173.173,0,0,0,.28.2l4.333-4.42a.173.173,0,0,0-.1-.294Z",
    transform: "translate(-1437.027 -307.543)",
    fill: "#fbae47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M1460.364,322.52a1.572,1.572,0,1,0-.437,3.114",
    transform: "translate(-1444.149 -301.86)",
    fill: "none",
    stroke: "#faad47",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -35.24, -5.71)",
    filter: "url(#Path_833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833-2",
    "data-name": "Path 833",
    d: "M1482.61,255.658l-4.661-.655a10.946,10.946,0,0,0-12.327,9.288l-.678,4.818,4.037.568,1.217-4.631.018,4.8,3.074.432,1.224-6.091-.292,6.222,3.707.521.592-3.1.213,3.209,7.114,1,.178-7.942,1.057,8.116,4.139.582.677-4.818A10.946,10.946,0,0,0,1482.61,255.658Z",
    transform: "translate(-1413.36 -248.9)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M1497.188,341.03a10.964,10.964,0,0,1-4.529-2.286,1.818,1.818,0,0,0-2.015,1.366l-1.256-.176a4.6,4.6,0,1,0,9.113,1.281Z",
    transform: "translate(-1465.658 -313.2)",
    fill: "#ec008c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(0.289 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M1103.389,521.745a2.265,2.265,0,0,0-2.265,2.265v9.021a2.265,2.265,0,0,0,2.265,2.265h38.388a13.551,13.551,0,0,0,13.551-13.551Z",
    transform: "translate(-1072.184 -438.339)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_635",
    "data-name": "Rectangle 635",
    width: 38.041,
    height: 12.994,
    transform: "translate(11.768 42.989)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M0,54.22V6.945A6.944,6.944,0,0,1,6.944,0h2.1a4.516,4.516,0,0,1,4.511,4.511V54.22H0Z",
    transform: "translate(0 42.989)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M1152.752,387.469h-2.1a4.511,4.511,0,0,0-4.511,4.511V434.9a6.776,6.776,0,0,0,6.776,6.776h0a6.776,6.776,0,0,0,6.776-6.776V394.413A6.944,6.944,0,0,0,1152.752,387.469Z",
    transform: "translate(-1103.654 -344.48)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M1059.24,387.469a10.308,10.308,0,0,1-20.4,0h-10.979v54.2h42.492v-54.2Z",
    transform: "translate(-1020.971 -344.48)",
    fill: "#ea088b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(10.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M1039.578,319.507a4.021,4.021,0,0,0,4.381,3.625l-.756-8.005A4.021,4.021,0,0,0,1039.578,319.507Z",
    transform: "translate(-1039.085 -294.745)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M1132.666,307.429l.756,8.005a4.021,4.021,0,0,0-.756-8.005Z",
    transform: "translate(-1104.722 -289.352)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 7.364,
    cy: 7.364,
    r: 7.364,
    transform: "translate(14.261 7.413)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 7.364,
    cy: 7.364,
    r: 7.364,
    transform: "translate(2.538 8.873)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 24.413,
    height: 32.898,
    rx: 12.207,
    transform: "translate(2.548 5.886) rotate(-5.398)",
    fill: "#f3d1a5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 5.728,
    cy: 5.728,
    r: 5.728,
    transform: "translate(9.237)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 5.384,
    cy: 5.384,
    r: 5.384,
    transform: "matrix(0.637, -0.77, 0.77, 0.637, 0, 10.618)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 4.738,
    cy: 4.738,
    r: 4.738,
    transform: "translate(17.695 4.643) rotate(-14.592)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 0.811,
    cy: 0.811,
    r: 0.811,
    transform: "translate(11.269 21.062)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 0.811,
    cy: 0.811,
    r: 0.811,
    transform: "translate(19.776 20.259)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M1102.737,303.8l-3.056-1.021a.942.942,0,0,0-.6,1.787l3.056,1.021a.942.942,0,1,0,.6-1.787Z",
    transform: "translate(-1080.52 -287.419)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M4.061,0,.854.307a.942.942,0,0,0,.177,1.876l3.207-.3A.942.942,0,1,0,4.061,0Z",
    transform: "translate(8.515 17.095) rotate(-17)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M1080.508,343.483a4.563,4.563,0,1,0,9.086-.859Z",
    transform: "translate(-1067.986 -313.966)",
    fill: "#2e2e2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M1102.749,336.3l-4.727-1a1.413,1.413,0,1,0-.588,2.765l4.727,1a1.413,1.413,0,1,0,.588-2.764Z",
    transform: "translate(-1079.034 -309.93)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M1077.975,336.435h0a1.417,1.417,0,0,0-1.906-.6l-4.284,2.237a1.413,1.413,0,0,0,1.308,2.506l4.284-2.237A1.417,1.417,0,0,0,1077.975,336.435Z",
    transform: "translate(-1061.356 -310.346)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M1044.09,296.262a4.02,4.02,0,0,0,4.381,3.625l-.756-8.005A4.021,4.021,0,0,0,1044.09,296.262Z",
    transform: "translate(-1042.516 -278.496)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M1123.88,285.44l.756,8.005a4.021,4.021,0,0,0-.756-8.005Z",
    transform: "translate(-1098.302 -273.981)",
    fill: "#f05a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M1069.473,278.815l-21.348,2.017a2.684,2.684,0,0,0,.5,5.344l21.348-2.017a2.684,2.684,0,1,0-.5-5.344Z",
    transform: "translate(-1043.65 -269.354)",
    fill: "#faad47"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.5, -2.92)",
    filter: "url(#Ellipse_82)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82-2",
    "data-name": "Ellipse 82",
    cx: 3.42,
    cy: 3.42,
    r: 3.42,
    transform: "translate(14.17 13.3)",
    fill: "#f05a26"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10.5, -2.92)",
    filter: "url(#Path_851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851-2",
    "data-name": "Path 851",
    d: "M1076.624,327.035l.162,1.726a9.494,9.494,0,0,1-8.534,10.315l-2.476.234a9.494,9.494,0,0,1-10.315-8.534l-.163-1.726-1.575.149.915,9.686a7.017,7.017,0,0,0,7.646,6.326l10.479-.99a7.017,7.017,0,0,0,6.326-7.646l-.915-9.687Z",
    transform: "translate(-1038.76 -300.05)",
    fill: "#f05a26"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M1070.131,465.38l14.235-19.294a.671.671,0,0,0-.54-1.07H1074.8a.671.671,0,0,1-.557-1.047l8.4-12.427a.671.671,0,0,0-.557-1.047h-10.449a.671.671,0,0,0-.631.444l-6.664,18.5a.672.672,0,0,0,.633.9h7.573a.672.672,0,0,1,.641.871l-4.24,13.574a.671.671,0,0,0,1.182.6Z",
    transform: "translate(-1046.446 -374.555)",
    fill: "#faad47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M1028.46,409.563",
    transform: "translate(-1021.391 -359.924)",
    fill: "none",
    stroke: "#99c700",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M.128,13.551H0V0H.128A6.732,6.732,0,0,1,4.919,1.984a6.776,6.776,0,0,1,0,9.583A6.732,6.732,0,0,1,.128,13.551Z",
    transform: "translate(0 43.217)",
    fill: "url(#linear-gradient)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.51cd8412c0462987ebcb82421ad195f3.svg";
export { ForwardRef as ReactComponent };